import { defineMessages } from 'react-intl';

export default defineMessages({
  announcePaginatedCodeSearchResults: {
    id: 'frontbucket.search.sourceBrowser.paginatedCodeSearchResultsCount',
    description: 'Announce code results after filtering with with pages info',
    defaultMessage:
      'Code results have been filtered, {count, plural, one {one code result has} other {{count} code results have}} been displayed on page {currentPage} of {totalPages}',
  },
  announceCodeSearchResults: {
    id: 'frontbucket.search.sourceBrowser.codeSearchResultsCount',
    description: 'Announce code results after filtering',
    defaultMessage:
      'Code results have been filtered, {count, plural, one {one code result has} other {{count} code results have}} been displayed',
  },
  announceNoCodeSearchResults: {
    id: 'frontbucket.search.sourceBrowser.noCodeSearchResults',
    description: 'Announce no code results found after filtering',
    defaultMessage:
      'Code results have been filtered, no search results were found',
  },
});
